import { GtqyClientProvider, SessionProvider } from '@vrplatform/data';
import type { ReactNode } from 'react';

type AppRouterProps = {
  children: ReactNode;
};

export function DBProvider(props: AppRouterProps) {
  return (
    <GtqyClientProvider>
      <SessionProvider>{props.children}</SessionProvider>
    </GtqyClientProvider>
  );
}
